import { render, staticRenderFns } from "./BrandIntroProductTemplate.vue?vue&type=template&id=78039e48"
import script from "./BrandIntroProductTemplate.vue?vue&type=script&lang=js"
export * from "./BrandIntroProductTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports